import { Component, ElementRef, OnInit, Inject, LOCALE_ID } from '@angular/core';
import { UserService } from '../user.service';
import { HttpClient } from '@angular/common/http';
import {  from } from 'rxjs';
import {concatMap} from 'rxjs/operators'
import { ToastrService } from 'ngx-toastr';
import { formatNumber } from '@angular/common';


@Component({
  selector: "app-optimize",
  templateUrl: "./optimize.component.html",
  styleUrls: ["./optimize.component.scss"],
})
export class OptimizeComponent implements OnInit {
  constructor(
    public user: UserService,
    private el: ElementRef,
    private http: HttpClient,
    private toastr: ToastrService,
    @Inject(LOCALE_ID) private locale: string

  ) {}

  portfolio_percent: string;
  rateOfReturn:string;
  standardDeviation:string;
  portfolio_value: any;
  payloads = [];
  portfolio_percentages = [10, 20, 30, 40, 50, 60, 70, 80, 90];
  merged_allocation = [];
  optimized_statistic: any;
  isShowLoader = false;
  uuid:string;
  myTimer:any;
  current_statistics:any;
  merged_stats:any;

  ngOnInit() {

    this.user.ChaptimizerPercent.subscribe((percent) => {
      this.portfolio_percent = percent;
    });

    this.user.Rate_Of_Return.subscribe((percent) => {
      this.rateOfReturn = percent;
    });

    this.user.StandardDeviation.subscribe((percent) => {
      this.standardDeviation = percent;
    });

    if(this.user.timer_id){
      this.myTimer=this.user.timer_id;
    }

    // this.portfolio_value = this.user.portfolioValue;

    this.user.portfolioValueSource.subscribe(portfolio_value=>{
      this.portfolio_value=portfolio_value;
    })


    if (this.user.portfolio_percentages) {
      this.portfolio_percentages = this.user.portfolio_percentages;
    }

    if (this.user.optimized_statistics) {
      this.optimized_statistic = this.user.optimized_statistics;
    }

    if (this.user.merged_allocation) {
      this.merged_allocation = this.user.merged_allocation;
    } else {
      this.createMergedAllocationArray();
    }

    this.user.getStatistic(localStorage.getItem('current_have_statistic')).subscribe(statistic =>{
      this.current_statistics = statistic;
    });

  }

  editChaptimizerPercent(percent) {
    this.user.editChaptimizerPercent(percent);
  }

  editRateOfReturn(ror) {
    this.user.editRateOfReturn(ror);
  }

  editStandardDeviation(std) {
    this.user.editStandardDeviation(std);
  }

  //creating an empty array for merged allocation table
  createMergedAllocationArray() {
    this.portfolio_percentages.forEach((percent) => {
      this.merged_allocation.push({"statistics":{
        "amount_of_money_at_risk":null,
        "lower_return": null,
        "probability_of_any_loss": null,
        "rate_of_return": null,
        "sharpe_ratio": null,
        "standard_deviation": null,
        "upper_return": null,
        "variance_drag_phantom_tax": null,
        "Beta to the S&P 500":null
      }});
    });
  }

  addPortfolioPercent() {
    if (!this.portfolio_percentages.includes(Number(this.portfolio_percent))) {
      this.portfolio_percentages.push(Number(this.portfolio_percent));
      this.portfolio_percentages.sort((a, b) => a - b);
      this.user.portfolio_percentages = this.portfolio_percentages;
      this.merged_allocation = [];
      this.createMergedAllocationArray();
    }
    this.merged_allocation = [];
    this.createMergedAllocationArray();
  }



  getData(){
    if (this.myTimer != undefined) {
      clearInterval(this.myTimer);
    }
    this.uuid=this.getUniqueId()

    this.myTimer=setInterval(()=>{
    this.user.getOptimizeStatsURL(this.uuid).subscribe(response=>{
        let res:any=response
        if(res.statistics != null){
          this.optimized_statistic=res.statistics;
          this.user.optimized_statistics=this.optimized_statistic;
          this.rateOfReturn = String(this.transformDecimal(this.optimized_statistic.rate_of_return * 100));
          this.editRateOfReturn(this.rateOfReturn)
          this.standardDeviation = String(this.transformDecimal(this.optimized_statistic.standard_deviation * 100));
          this.editStandardDeviation(this.standardDeviation)
          this.getMergedData({"investment_amount": this.portfolio_value,
                              "target_value": this.optimized_statistic.rate_of_return * 100,
                              "max_standard_deviation": this.optimized_statistic.standard_deviation * 100,
                              "current_statistics":this.current_statistics,
                              "percentages":this.portfolio_percentages})
        }
      },
      (error)=>{
        this.showError()
      })
    },15000)
    this.user.timer_id=this.myTimer;
  }

  validateInput(){
    if(this.current_statistics==undefined){
      this.toastr.warning("Current Allocation is empty!")
    }
    else if(this.portfolio_value==''){
      this.toastr.warning("Portfolio value cannot be zero!")
      return false
    }
    else if(this.portfolio_percent==''){
      this.toastr.warning("Please enter allocation percentage!")
      return false
    }
    else if(this.rateOfReturn==''){
      this.toastr.warning("Please enter desired rate of return!")
      return false
    }
    else if(this.standardDeviation==''){
      this.toastr.warning("Please enter desired standard deviation!")
      return false
    }

    else {
      return true
    }
  }

optimize() {
  if (this.myTimer != undefined) {
    clearInterval(this.myTimer);
  }

      if (this.validateInput()) {
        this.addPortfolioPercent();
        // this.spinner.show();
        this.user.isSaving=true
        let obj = {
          investment_amount: Number(this.portfolio_value),
          allocation_percent: Number(this.portfolio_percent),
          current_allocation: [],
          current_statistics:null
        };

        let optimizeObj = {
        "investment_amount":(Number(this.portfolio_percent)/100) * this.portfolio_value,
        "mode":"maximize",
        "target_value":Number(this.rateOfReturn),
        "maximum_allocation":100,
        "max_standard_deviation":this.standardDeviation,
        "allocation_constraints": [],
        "uuid":null,
        "current_statistics":this.current_statistics
        };
          this.http.post(this.user.getEndpointURL(), optimizeObj).subscribe(
            (stats) => {
              this.optimized_statistic=null;
              let optimized_statistic = stats["statistics"];
              this.optimized_statistic=optimized_statistic;
            },
            (error) => {
              console.log(error);
              this.showError()
              // this.spinner.hide();
            },
            () => {
              // this.spinner.hide();
              this.user.isSaving=false
              this.user.optimized_statistics = this.optimized_statistic;
              this.getMergedData();
            }
          );
      }
  }

  //getting merged statistics
  getMergedData(payload=null){
    // this.spinner.show();
    this.user.isSaving=true;
    let payloadObj={
      "investment_amount": this.portfolio_value,
      "target_value": this.rateOfReturn,
      "max_standard_deviation": this.standardDeviation,
      "current_statistics":{...this.current_statistics,'beta':localStorage.getItem('beta_avg')},
      "percentages":this.portfolio_percentages
    }
    let obj=payload!=null ? payload : payloadObj
    this.http.post(this.user.getOptimizeURL(),obj)
    .subscribe(res=>{
      this.user.isSaving=false;
      this.merged_allocation=Object.values(res);
      let index=this.portfolio_percentages.indexOf(Number(this.portfolio_percent))
      if (this.portfolio_percentages.indexOf(Number(this.portfolio_percent)) == index) {
        this.user.merged_statistics = this.merged_allocation[index].statistics;
      }
      this.user.merged_allocation=this.merged_allocation;
    },
    (error)=>{
      this.showError();
      this.user.isSaving=false;

      // this.spinner.hide()
    },
    ()=>{
      console.log("All Done...!!")
      // this.spinner.hide()
      this.user.isSaving=false;

    })

  }

  transformDecimal(num) {
    return formatNumber(num,this.locale,'1.2-2')
  }

  roundValues(val) {
    return Math.round(val);
  }

  getUniqueId(){
    return (new Date().getTime()).toString(36) + new Date().getUTCMilliseconds();
  }

  showError(){
    this.toastr.error("Something went wrong!");
  }

}
